export function Base64Encode(data: Uint8Array): string {
  return btoa(String.fromCharCode(...data))
}
